import { Box, IconButton, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import { type FC, useState } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { CommentParentTableType } from "@/graphql/codegen/graphql"

interface CustomerProductCommentsSectionProps {
  companyProductAssociationLocationId: string
}

export const CustomerProductCommentsSection: FC<CustomerProductCommentsSectionProps> = ({
  companyProductAssociationLocationId,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <Box className='rounded-md border border-solid border-gray-400 p-6'>
      <Box className='flex items-center justify-between'>
        <Typography className='text-ml font-normal text-gray-900'>Comments</Typography>
        <IconButton
          size='small'
          onClick={() => setIsExpanded((prev) => !prev)}
          data-testid='customer-product.comments-section.expand-button'
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>

      {isExpanded && (
        <Box className='pt-4'>
          <CommentsSection
            referenceId={companyProductAssociationLocationId}
            type={CommentParentTableType.CustomerProductPreference}
          />
        </Box>
      )}
    </Box>
  )
}
